import {
  Avatar,
  Box,
  Label,
  SystemIcon,
  Typography,
} from '@wishket/design-system';

interface CommentItemProps {
  imgUrl?: string;
  username: string;
  parentUsername?: string;
  comment: string;
  time: string;
  isEditable?: boolean;
  isReply?: boolean;
  isAuthor?: boolean;
  isModified?: boolean;
  onReply?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

const EDITED_TEXT = ' 수정됨';

const CommentItem = ({
  imgUrl,
  username,
  parentUsername,
  comment,
  time,
  isReply = false,
  isEditable = false,
  isAuthor = false,
  isModified = false,
  onReply,
  onEdit,
  onDelete,
}: CommentItemProps) => {
  const isSelfReply = username === parentUsername;

  return (
    <Box className="flex w-full gap-4">
      {isReply && (
        <SystemIcon name="medium_reply" className="text-w-gray-400" />
      )}
      <Box className="flex w-full flex-col items-start gap-3">
        <Box className="flex w-full items-center justify-between gap-8">
          <Box className="flex w-full items-center justify-start gap-2">
            <Avatar size="sm" imgUrl={imgUrl} />
            <Typography variant="body1" className="font-medium text-w-gray-600">
              {username}
            </Typography>
            {isAuthor && (
              <Label.Root type="filled" size="sm">
                <Label.Text>작가</Label.Text>
              </Label.Root>
            )}
          </Box>
          {isEditable && (
            <Box className="flex w-fit shrink-0 items-center gap-4">
              <button onClick={onEdit}>
                <Typography
                  variant="body1"
                  className="font-medium text-primary hover:underline"
                >
                  수정
                </Typography>
              </button>
              <button onClick={onDelete}>
                <Typography
                  variant="body1"
                  className="font-medium text-w-gray-600 hover:underline"
                >
                  삭제
                </Typography>
              </button>
            </Box>
          )}
        </Box>
        <Box className="flex w-full flex-col gap-1.5">
          <Typography
            variant="body1"
            className="whitespace-pre-wrap break-all text-w-gray-600"
          >
            {!isSelfReply && parentUsername && (
              <span className="font-medium">@{parentUsername} </span>
            )}
            {comment}
          </Typography>
          <Typography variant="body1" className="text-w-gray-400">
            {time}
            {isModified && EDITED_TEXT}
          </Typography>
        </Box>
        <button onClick={onReply}>
          <Typography
            variant="body2"
            className="cursor:pointer text-w-gray-600 underline"
          >
            답글 달기
          </Typography>
        </button>
      </Box>
    </Box>
  );
};

export default CommentItem;
